<template>
  <div class="d-flex flex-column gap-6">
    <basic-question
      v-model="modelValue.blockedActivitiesRate"
      kind="radio"
      title="A asma prejudicou suas atividades no trabalho, na escola ou em casa?"
      :questionData="{
        options: {
          'Nenhuma vez': 5,
          'Poucas vezes': 4,
          'Algumas vezes': 3,
          'Maioria das vezes': 2,
          'Todo o tempo': 1,
        },
      }"
      :disabled="disabled"
    />
    <basic-question
      v-model="modelValue.lackOfAirRate"
      kind="radio"
      title="Como está o controle da sua asma?"
      :questionData="{
        options: {
          'Totalmente descontrolada': 1,
          'Pobremente controlada': 2,
          'Um pouco controlada': 3,
          'Bem controlada ': 4,
          'Completamente controlada': 5,
        },
      }"
      :disabled="disabled"
    />
    <basic-question
      v-model="modelValue.nightAwakeningsRate"
      kind="radio"
      title="Quantas vezes você teve falta de ar?"
      :questionData="{
        options: {
          'De jeito nenhum': 5,
          'Uma ou duas vezes por semana ': 4,
          'Três a seis vezes por semana': 3,
          'Uma vez ao dia': 2,
          'Mais que uma vez ao dia': 1,
        },
      }"
      :disabled="disabled"
    />
    <basic-question
      v-model="modelValue.inhalorUsageRate"
      kind="radio"
      title="A asma acordou você à noite ou mais cedo que de costume?"
      :questionData="{
        options: {
          'De jeito nenhum': 5,
          'Uma ou duas vezes': 4,
          'Uma vez por semana': 3,
          'Duas ou três noites por semana': 2,
          'Quatro ou mais noites por semana': 1,
        },
      }"
      :disabled="disabled"
    />
    <basic-question
      v-model="modelValue.asthmaControl"
      kind="radio"
      title="Quantas vezes você usou o remédio por inalação para alívio?"
      :questionData="{
        options: {
          'De jeito nenhum': 5,
          'Uma vez por semana ou menos': 4,
          'Poucas vezes por semana': 3,
          'Uma ou duas vezes por dia': 2,
          'Três ou mais vezes por dia ': 1,
        },
      }"
      :disabled="disabled"
    />
  </div>
</template>

<script>
import { PropOptions, WatchOptionsWithHandler } from 'vue'
import { cloneDeep, isEmpty } from 'lodash'
import BasicQuestion from '@/components/NewAttendanceForm/Questions/Basic/BasicQuestion.vue'

/**
 * @typedef {Object} ModelValue
 * @property {number?} blockedActivitiesRate
 * @property {number?} lackOfAirRate
 * @property {number?} nightAwakeningsRate
 * @property {number?} inhalorUsageRate
 * @property {number?} asthmaControl
 */

export default {
  name: 'ActGeneralQuestions',
  components: {
    BasicQuestion,
  },
  props: {
    /** @type {PropOptions<ModelValue>} */
    value: {
      type: Object,
    },
    /** @type {PropOptions<boolean>} */
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    /** @type {ModelValue} */
    const initialValue = {
      blockedActivitiesRate: null,
      lackOfAirRate: null,
      nightAwakeningsRate: null,
      inhalorUsageRate: null,
      asthmaControl: null,
    }

    /** @type {ModelValue} */
    const modelValue = isEmpty(this.value) ? initialValue : { ...initialValue, ...cloneDeep(this.value) }

    return {
      modelValue,
    }
  },
  watch: {
    /** @type {WatchOptionsWithHandler<ModelValue>} */
    modelValue: {
      handler(value) {
        this.$emit('input', value)
      },
      deep: true,
    },
  },
}
</script>

<style></style>
